<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaPremiu')}} </h4>
        </div>
        <form class="add-prize-container" id="prize-form">
            <input type="hidden" name="_method" value="put" />
            <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                <div class="form-group" v-for="prize_field in add_prize_fields" :key="prize_field.id">
                    <input :type="prize_field.type" class="form-control"
                           placeholder=""
                           v-validate="prize_field.validationRules"
                           :name="prize_field.inputName"
                           v-model="prize_field.inputValue"
                           :data-vv-as="prize_field.labelName"
                           :id="prize_field.inputName">
                    <label class=""> {{prize_field.labelName}} </label>
                    <span class="focus-input"></span>
                    <span class="symbol-input">
                                <i v-bind:class="prize_field.icon"></i>
                            </span>
                    <p class="custom-error-info"> {{errors.first(prize_field.inputName)}} </p>
                </div>
                <div class="add-prize-wrapper">
                    <b-form-file
                            name="files[]"
                            v-model="file"
                            ref="file-input"
                            :state="Boolean(file)"
                            :placeholder="$t('placeholder.dropPhotoHere')"
                            :drop-placeholder="$t('placeholder.dropPhotoHere')"
                    ></b-form-file>
                    <div class="reset-files-wrapper" v-if="file">
                        <b-button @click="clearFiles" class="reset-files-button"> {{$t('txt.eliminaFisiereleIncarcate')}}
                        </b-button>
                    </div>
                    <div class="create-prize-description">
                        <textarea v-model="this.description" :placeholder="$t('placeholder.descrierePremiu')" name="description"></textarea>
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                <div class="save-prize">
                    <button class="template-button" type="button" @click="savePrize()">
                        <i class="far fa-save"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import PrizesService from '../../api-services/prizes.service.js'
export default {
  name: 'editprize',
  data () {
    return {
      file: null,
      prize: {
        title: null,
        points: null
      },
      mimes: ['image/jpeg', 'image/jpg', 'image/png'],
      description: null
    }
  },
  methods: {
    clearFiles () {
      this.$refs['file-input'].reset()
    },
    getPrize () {
      return new Promise((resolve, reject) => {
        PrizesService.get(this.$route.params.id)
          .then((response) => {
            this.prize = response.data.data
            this.description = this.prize.description
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    savePrize () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('prize-form'))
      // this.adjustLoadingContainer()
      PrizesService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 200) {
            this.$notify({
              group: 'succes',
              type: 'success',
              text: this.$t('success.premiulModificat'),
              'animation-type': 'css'
            })
            window.scrollTo(0, 0)
            this.$router.push({ name: 'prizes' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) return
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.getPrize()
  },
  computed: {
    add_prize_fields () {
      return [
        {
          inputName: 'title',
          labelName: this.$t('placeholder.numePremiu'),
          inputValue: (this.prize) ? this.prize.title : '',
          icon: 'fas fa-signature',
          validationRules: ''
        },
        {
          inputName: 'points',
          labelName: this.$t('placeholder.punctePremiu'),
          inputValue: (this.prize) ? this.prize.points : '',
          icon: 'far fa-star',
          validationRules: '',
          type: 'number'
        }
      ]
    }
  }
}
</script>
